/** F606 Subscriptions page — active subscription tracking. */
import { CreditCard } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606SubscriptionsPage() {
  return (
    <F606DataPage
      entity="subscriptions"
      titleAr="الاشتراكات"
      titleEn="Subscriptions"
      icon={CreditCard}
      emptyIcon={CreditCard}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        {
          key: 'user_name',
          ar: 'المشترك', en: 'Subscriber',
          render: (r) => (
            <div>
              <div className="font-bold text-white">{r.user_name || r.subscriber_name || '—'}</div>
              {r.user_email && <div className="text-[10px] text-white/40 font-mono" dir="ltr">{r.user_email}</div>}
            </div>
          ),
        },
        { key: 'plan_name', ar: 'الخطة', en: 'Plan', render: (r) => r.plan_name || r.plan || '—' },
        {
          key: 'amount',
          ar: 'المبلغ', en: 'Amount',
          render: (r) => r.amount != null ? <span className="font-mono font-bold text-emerald-300" dir="ltr">{Number(r.amount).toFixed(2)} {r.currency || 'AED'}</span> : '—',
          className: 'w-32',
        },
        {
          key: 'status',
          ar: 'الحالة', en: 'Status',
          render: (r) => {
            const s = String(r.status || '').toLowerCase();
            const color = s === 'active' ? 'emerald' : s === 'cancelled' ? 'red' : s === 'expired' ? 'white/40' : 'amber';
            return (
              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold border bg-${color}-500/15 border-${color}-500/40 text-${color}-300`}>
                {r.status || '—'}
              </span>
            );
          },
          className: 'w-28',
        },
        {
          key: 'expires_at',
          ar: 'ينتهي في', en: 'Expires',
          render: (r) => r.expires_at ? new Date(r.expires_at).toLocaleDateString() : (r.next_billing_at ? new Date(r.next_billing_at).toLocaleDateString() : '—'),
          className: 'w-28 text-[11px] text-white/60',
        },
      ]}
    />
  );
}
